export const routeConfig = {
  meta: {
    title: '角色设置',
  },
};

